import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

import { BasicInformationTab } from "./BasicInformationTab";
import { UiConfigurationTab } from "./UiConfigurationTab";
import {
  fecthTz,
  fetchBusinessGroup,
  fetchNumberSequence,
  selectLoading,
} from "./businessGroupSlice";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  fetchParameter5,
  fetchParameter6,
} from "../businessParameter/businessParameterSlice";
import { useDispatch, useSelector } from "react-redux";
import { paginationSet } from "../../utility";
import { fetchCountryAll } from "../location/locationSlice";

export const BusinessGroupPage = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const [active, setActive] = useState("Basic Information");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "PHONETYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter3({
          paramgroup_code: "DIGITGROUPING",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter4({
          paramgroup_code: "PAGINATION",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter5({
          paramgroup_code: "DATEFORMAT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchNumberSequence({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchParameter6({
          paramgroup_code: "CULTURE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(fecthTz());
    }

    fetchMyAPI();
  }, [dispatch]);

  return (
    <>
      <div>
        <Tabs
          defaultActiveKey="Basic Information"
          id="uncontrolled-tab-example"
          onSelect={(e) => setActive(e)}
        >
          <Tab eventKey="Basic Information" title="Basic Information">
            <BasicInformationTab active={active} />
          </Tab>
          <Tab eventKey="UI Configuration" title="UI Configuration">
            <UiConfigurationTab active={active} />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};
